"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Neccessary so that all new items being pushed into an array can be reflected and proxied
 * if neccesary (e.g. dynamic objects).
 */
var proxiedUnshift = function (arr, proxyNode, newItems) {
    var proxy = proxyNode.proxy;
    var proxies = proxyNode.children;
    var newItemsCount = newItems.length;
    var len = arr.length;
    // Rotate array values along by an amount equal to the new items to
    // be unshifted into the array
    for (var i = len - 1; i > -1; i--) {
        var tempValue = arr[i];
        arr[i + newItemsCount] = tempValue;
        // Delete all existing proxies at affected indices (proxies can not be rotated
        // as they contain closed-over paths pointing to their original indices)
        delete proxies[i];
    }
    while (newItems.length) {
        var newItem = newItems.pop();
        proxy[newItems.length] = newItem;
    }
    return arr.length;
};
exports.default = proxiedUnshift;
//# sourceMappingURL=proxiedUnshift.js.map